import Optimizely from '@optimizely/optimizely-sdk'
// eslint-disable-next-line no-restricted-imports
import * as Opticks from 'opticks'

import fallbackDataFile from '../../modules/fallbackDataFile'

interface Props {
  children: JSX.Element
  /** The user ID to use for the Opticks library */
  userId: string
}

/**
 * A simplified provider for Opticks that initializes the library with a fallback data file and a placeholder user ID.
 * All `toggle` calls will return the A-side variant.
 * @param props
 * @param props.children - The children components.
 * @param props.userId - The user ID to use for the Opticks library.
 */
const DummyOpticksProvider = ({children, userId}: Props) => {
  Optimizely.setLogger(null)

  Opticks.registerLibrary(Optimizely)
  Opticks.initialize(fallbackDataFile)
  Opticks.setUserId(userId)

  return children
}

export default DummyOpticksProvider
